import { departments } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IDepartmentData, IDepartments } from "../../models/master/department";
import { IHelpMail } from "../../models/common/IHelpMail";

 export default new (class DepartmentService {
    
  public getDepartment = async (
    id?: number
  ): Promise<IApiResponse<IDepartmentData>> => {
    try {
      let endPoint = id?  urlBinder(departments.GET_DEPARTMENT_WITH_ID, [id] ) : departments.GET_DEPARTMENT_WITHOUT_ID ;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDepartmentData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDepartmentData>;
      } else {
        throw error;
      }
    }
  }

  public getDepartments = async (
  ): Promise<IApiResponse<Array<IDepartments>>> => {
    try {
      let endPoint = departments.GET_ALL_DEPARTMENTS;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IDepartments>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IDepartments>>;
      } else {
        throw error;
      }
    }
  };

  public createDepartment = async (
    data: any
  ): Promise<IApiResponse<boolean|any>> => {
    try {
      let endPoint = departments.CREATE_DEPARTMENT;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean|any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean|any>;
      } else {
        throw error;
      }
    }
  };

  public updateDepartment = async (
    data: any,id:number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(departments.UPDATE_DEPARTMENT, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteDepartment = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(departments.DELETE_DEPARTMENT, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };

  public getEmailIdByDepartment = async (
  ): Promise<IApiResponse<Array<IHelpMail>>> => {
    try {
      let endPoint = departments.GET_DEPARTMENT_MAIL_ID;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IHelpMail>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IHelpMail>>;
      } else {
        throw error;
      }
    }
  };
})();
